import React, { useState } from 'react';

function Login({ onLogin, error }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(username, password);
  };

  return (
    <div style={{
      minHeight: '70vh',
      display: 'flex',
      flexDirection: 'row',
      boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      borderRadius: 12,
      overflow: 'hidden',
      maxWidth: 800,
      margin: '60px auto',
      background: '#fff',
    }}>
      {/* Left: Image */}
      <div style={{
        flex: 1,
        background: '#eaf0fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 0,
        minHeight: 400,
      }}>
        <img
          src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80"
          alt="Logistics"
          style={{ width: '100%', height: '100%', objectFit: 'cover', maxHeight: 420 }}
        />
      </div>
      {/* Right: Login Form */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 36,
        minWidth: 0,
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 24 }}>
          <img src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f69a.svg" alt="Logistics Logo" style={{ width: 48, height: 48, marginBottom: 8 }} />
          <span style={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', letterSpacing: 1, lineHeight: 1.2, color: '#1a355e' }}>Swift Logistics ERP</span>
        </div>
        <h2 style={{ textAlign: 'center', marginBottom: 20 }}>Admin Login</h2>
        <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: 260 }}>
          <div style={{ marginBottom: 10 }}>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={e => setUsername(e.target.value)}
              style={{ width: '100%', padding: 8 }}
              autoFocus
            />
          </div>
          <div style={{ marginBottom: 10 }}>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={{ width: '100%', padding: 8 }}
            />
          </div>
          {error && <div style={{ color: 'red', marginBottom: 10 }}>{error}</div>}
          <button type="submit" style={{ width: '100%', padding: 8 }}>Login</button>
        </form>
      </div>
      {/* Responsive: Stack on small screens */}
      <style>{`
        @media (max-width: 700px) {
          .login-split-root {
            flex-direction: column !important;
            min-height: unset !important;
            max-width: 98vw !important;
          }
          .login-split-img {
            min-height: 180px !important;
            max-height: 180px !important;
          }
        }
      `}</style>
    </div>
  );
}

export default Login; 